import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import { useCopyText } from "@shared/hooks/useCopyText";
import { IconButton, TypographyProps } from "@mui/material";
import { TableText } from "../../../shared/components/Table/styles";

interface Props extends TypographyProps {
  text: string;
}

export const CopyableText = (props: Props) => {
  const { text, children, ...rest } = props;
  const { handleCopyText, isCopied } = useCopyText();

  return (
    <TableText {...rest}>
      {children}
      <IconButton
        onClick={() => handleCopyText(text)}
        size="small"
        color="secondary"
      >
        {isCopied ? (
          <CheckIcon fontSize="small" color="success" />
        ) : (
          <ContentCopyIcon fontSize="small" color="secondary" />
        )}
      </IconButton>
    </TableText>
  );
};
